<template>
  <div>
    <b-modal
      :active.sync="modalCreateClassroom"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-modal
    >
      <set-classroom @over="modalCreateClassroom = false" />
    </b-modal>
    <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
    <!-- <b-modal 
    :active.sync="modalUpdateClassroom"
    has-modal-card
    trap-focus
    :destroy-on-hide="true"
    aria-role="dialog"
    aria-modal>
    <set-classroom @over="modalUpdateClassroom=false" />
  </b-modal> -->
    <section class="hero is-flex main">
      <div class="bg-icon star">
        <img src="../assets/images/stars.png" alt="" />
      </div>
      <div class="title">Classroom</div>
      <div class="card-container">
        <div class="left-card">
          <div class="columns" style="width: 100%;">
            <div class="column is-3">
              <div class="buttons">
                <b-button type="is-primary" @click="modalCreateClassroom = true"
                  >Create Classroom</b-button
                >
              </div>
            </div>
          </div>
          <div class="columns" style="width: 100%;">
            <div class="column is-4">
              <b-field label="Subject">
                <b-select
                  @input="filterBy()"
                  v-model="filter.subject"
                  expanded
                  placeholder="Filter by subject here"
                >
                  <option
                    v-for="subject in fetchSubjects"
                    :key="subject._id"
                    :value="subject._id"
                    >{{ subject.name }}</option
                  >
                </b-select>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field label="Grade">
                <b-select
                  @input="filterBy()"
                  v-model="filter.grade"
                  expanded
                  placeholder="Filter by grade here"
                >
                  <option
                    v-for="grade in fetchGrades"
                    :key="grade._id"
                    :value="grade._id"
                    >{{ grade.name }}</option
                  >
                </b-select>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field label="Section">
                <b-select
                  @input="filterBy()"
                  v-model="filter.section"
                  expanded
                  placeholder="Filter by section here"
                >
                  <option
                    v-for="section in fetchSections"
                    :key="section._id"
                    :value="section._id"
                    >{{ section.name }}</option
                  >
                </b-select>
              </b-field>
            </div>
            
          </div>

          <ClassroomTable></ClassroomTable>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex"
import ClassroomTable from "@/components/School/ClassroomTable.vue";
import SetClassroom from "@/components/School/SetClassroom.vue";
export default {
  name: "Classrooms",
  components: {
    ClassroomTable,
    SetClassroom,
  },
  props: {},
  data() {
    return {
      modalCreateClassroom: false,
      isLoading: false,
      filter: {
        subject: null,
        grade: null,
      },
    };
  },
  methods: {
    ...mapActions(["loadGrades", "loadSections", "loadSubjects", "loadClassrooms"]),
    filterBy() {
      this.isLoading = true
      this.loadClassrooms({ token: this.getTeacherToken, filter : this.filter
      }).then(() => {
          this.isLoading = false
      });
    },
  },
  computed : {
    ...mapGetters(['fetchGrades', 'fetchSections', 'fetchSubjects', 'getTeacherToken']),
  },
  async created() {
    this.loadGrades({
      token: this.getTeacherToken,
    });
    this.loadSubjects({
      token: this.getTeacherToken,
    });
    this.loadSections({
      token: this.getTeacherToken,
    });
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap");
.flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.container {
  position: relative;
}

.bg-img {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.bg-img div {
  display: flex;
  position: absolute;
  width: auto;
}

.title {
  font-size: 3vw;
  margin: 0 !important;
}

img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.button {
  flex-direction: row;
  padding: 1vw 1.25vw;
  width: 100%;
  background: #8919e7;
  border-radius: 1vw;
  color: #fff;
  gap: 1vw;
  cursor: pointer;
  position: relative;
  text-transform: capitalize;
}
.button.outline {
  border: 0.063rem solid #8919e7;
  background: #fff;
  color: #000;
}
.link {
  cursor: pointer;
}
.main {
  align-items: center;
  margin: 0vw 0vw;
  position: relative;
  gap: 2.4vw;
}
/* responsive page*/
/* tablet */
@media screen and (max-width: 1023px) {
  .title {
    font-size: 3.5vw !important;
  }
}

/* Mobiles */
@media screen and (max-width: 767px) {
  .title {
    font-size: 4vw !important;
  }
}

@media screen and (max-width: 467px) {
  .title {
    font-size: 5vw !important;
  }
}
.bg-icon {
  position: absolute;
}

.star {
  left: 77vw;
  top: -1vw;
  max-width: 5vw;
}

.main {
  align-items: center;
  margin: 6.76vw 4.4vw;
  position: relative;
  gap: 2.4vw;
}
.main .card-container {
  display: flex;
  justify-content: center;
  gap: 2.2vw;
  width: 100%;
}
.main .card-container .left-card,
.main .card-container .right-card {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: flex-start;
  padding: 3.6vw 2vw;
  border-radius: 1.8vw;
}
.main .card-container .left-card {
  background: rgba(137, 25, 231, 0.1);
  justify-content: flex-start;
}
.main .card-container .left-card .button,
.main .card-container .right-card .button {
  max-width: -webkit-fit-content;
  max-width: -moz-fit-content;
  max-width: fit-content;
  padding: 1.2vw 5vw;
  border-radius: 1.1vw;
  font-size: 1.2vw;
}
.main .card-container .right-card {
  background: rgba(49, 200, 255, 0.0784313725);
  justify-content: flex-start;
}

@media screen and (max-width: 767px) {
  .main .card-container {
    flex-direction: column;
  }
  .main .card-container .right-card .svg {
    right: 5% !important;
  }
  .title {
    font-size: 3.5vw !important;
  }
}
.drag-sortable {
  float: left;
}

hr {
  margin: 0.5rem 0 !important;
}
</style>
